export const getPathWithoutSectionUrl = (path, { sectionUrl, postPageSectionUrl }) => {
  let currentSectionUrl = '';
  if (path.startsWith(sectionUrl)) {
    currentSectionUrl = sectionUrl;
  } else if (path.startsWith(postPageSectionUrl)) {
    currentSectionUrl = postPageSectionUrl;
  }
  return path.slice(currentSectionUrl.length);
};
